import { ProfilePageLayout } from '@modules/_shared/components/ProfilePageLayout';
import { useLocale } from '@shared/hooks/locale';

export const ClaimProfile = () => {
  const { t } = useLocale();
  return (
    <ProfilePageLayout
      intent="claim"
      target="agent"
      title={t('Homeowners already see you on RealAdvisor')}
      description={t(
        'Claim your profile for free. Decide what homeowners see, and turn that visibility into success.',
      )}
    />
  );
};
